export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

// Нууц үгийн бодлого: 12-64 тэмдэгт, зай зөвшөөрнө,
// том/жижиг үсэг, тоо, тусгай тэмдэгт заавал шаардахгүй.
export const validatorPassword = password => {
  if (password === undefined || password === null) {
    return false
  }
  const { length } = password
  return length >= 12 && length <= 64
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}
